import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SuppInvPaymentMethodComponent } from '../supp-inv-payment-method/supp-inv-payment-method.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-return-supplier-invoice',
  templateUrl: './return-supplier-invoice.component.html',
  styleUrls: ['./return-supplier-invoice.component.css']
})
export class ReturnSupplierInvoiceComponent implements OnInit {

  public menu_item_id = '57';
  public add_auth;

  search_Bank = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'searchField',
    'table_list': [{
      'table_name': '`bank_account`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
    }]
  };

  supplier_inv_model = {
    'table_name': 'supplier_invoice', 'supplier_invoice_id': '0', 'supplier_invoice_no': '',
    'supplier_no': '', 'invoice_no': '', 'invoice_date': '0000-00-00', 'amount': '', 'tax': '', 'discount': '',
    'payment_date': '0000-00-00', 'payment_method': '', 'cost_center': '0', 'acct_number': '0',
    'received': '1', 'transport_fee': '0', 'is_paid': '1', 'payment_voucher_no': '', 'comment': '',
    'purch_acct': '803001', 'tax_acct': '0', 'from_acct': '0', 'trans_acct': '802001'
  };

  model = {
    'table_name': 'return_supplier_invoice', 'return_supplier_invoice_id': '0', 'return_supplier_invoice_no': '0', 'supplier_no': '0',
    'supplier_invoice_no': '', 'return_date': '', 'total': '', 'tax_acct': '0', 'discount': '',
    'tax': '', 'ret_purch_acct': '', 'payment_method': '', 'acct_number': '', 'is_paid': '0', 'cost_center': '',
    'flag': 'new', 'key': 'return_supplier_invoice_id', 'cash_receipt_no': '0', 'status': '1', 'comment': '',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  data_model = {
    'final_total': '', 'paid_amount': '', 'rem_amount': '', 'is_paid': '0', 'return_date': new Date(),
    'final_total_ret': '', 'bank_acct_number': '0', 'mode': ''
  };

  payDialogRef: MatDialogRef<SuppInvPaymentMethodComponent>;

  public dp = [];
  private dp1 = [];
  displayedColumns1 = ['payment_type_name', 'amount'];
  dataSource1 = new MatTableDataSource(this.dp1);
  @ViewChild(MatSort) sort: MatSort;

  print_type;
  payment_list;
  // bankList = [];

  // for update 
  no = "";
  mode = "";
  type = '';
  invoice_detail = {};
  inv_payment_method = [];
  count = 0;
  supplier_invoice_item = [];
  all_payment_types = [];

  @HostListener('window:keydown', ['$event'])
  handleKeyDownEvent(event: KeyboardEvent) {
    if (event.key == "F7")
      this.saveInvoice('print');

    if (event.key == "F8")
      this.saveInvoice('save_only');
  }
  // @HostListener('document:keydown.F7', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   this.saveInvoice();
  // }

  Acct_Placeholder; Success_Msg; Error_Msg; No_Inv_Msg; Paid; Unpaid;
  Ret_No_Msg; Main; One_Item_Msg; Bank_Acct_Msg; Pay_Msg; Not_Counter_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private route: ActivatedRoute, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    this.search_Bank['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('No_Inv_Msg').subscribe((res: string) => {
      this.No_Inv_Msg = res;
    });

    translate.get('Paid').subscribe((res: string) => {
      this.Paid = res;
    });

    translate.get('Unpaid').subscribe((res: string) => {
      this.Unpaid = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Main').subscribe((res: string) => {
      this.Main = res;
    });

    translate.get('One_Item_Msg').subscribe((res: string) => {
      this.One_Item_Msg = res;
    });

    translate.get('Bank_Acct_Msg').subscribe((res: string) => {
      this.Bank_Acct_Msg = res;
    });

    translate.get('Pay_Msg').subscribe((res: string) => {
      this.Pay_Msg = res;
    });

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    });
  }


  ngOnInit() {

    // get leaf purchase return accts
    let parent_acct = this.applicationConstants.main_acct_config['expenses_acct'];
    let obj1 = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj1)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.model['ret_purch_acct'] = data.data['list'][0]['acct_number'];
      });

    this.route.params.subscribe(params => {
      if (params['no'] != undefined) {
        this.no = params['no'];

        if (this.no.indexOf('RET') != -1) {
          this.mode = 'edit';
          this.data_model['mode'] = 'edit';
        }
        else
          (document.getElementById('invoice_no') as HTMLInputElement).value = this.no;

        (document.getElementById('invoice_no') as HTMLInputElement).disabled = true;
        this.getInvInfo();
      }
    });

    // check add authorization
    if (this.no == '')
      this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    else
      this.add_auth = true;

    let query, obj;

    // ******************* Get All Payment Types to send array to supp_inv_payment_method component ******************* //
    query = this.queryList.all_paymentType;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.all_payment_types = data.data['list'];
        if (this.all_payment_types.length == 5)
          this.all_payment_types.splice(4, 1);

      });

    // END 
    this.print_type = this.utils.getParamValue('print_type');
    let default_payment_type = this.utils.getParamValue('default_payment_type');
    if (default_payment_type != undefined || default_payment_type != '') {
      query = "SELECT * FROM `payment_type` WHERE `status` = '1' AND `payment_type_key` = '" +
        default_payment_type + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.payment_list = data.data['list'];
        });
    }
  }

  getInvInfo() {
    let query;

    if (this.mode == 'edit') {
      query = "SELECT `return_supplier_invoice`.`return_supplier_invoice_id`, `return_supplier_invoice`.`branch_id`, " +
        "`return_supplier_invoice`.`return_supplier_invoice_no`, `return_supplier_invoice`.`return_date`, " +
        "`return_supplier_invoice`.`supplier_invoice_no`, `return_supplier_invoice`.`total` as 'ret_total', " +
        "`return_supplier_invoice`.`discount` as 'ret_discount', `return_supplier_invoice`.`tax` as 'ret_tax', " +
        "`return_supplier_invoice`.`comment` as 'ret_comment', `supplier_invoice`.* FROM " +
        "`return_supplier_invoice`, `supplier_invoice` WHERE `return_supplier_invoice`.`return_supplier_invoice_no` = '" +
        this.no + "' AND `return_supplier_invoice`.`supplier_invoice_no` = `supplier_invoice`.`invoice_no`";
    }
    else {
      let inv_no = (document.getElementById('invoice_no') as HTMLInputElement).value;
      query = "SELECT * FROM `supplier_invoice` WHERE `invoice_no` = '" + inv_no + "' AND `status` = '1'";
    }
    console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.data['list'].length == 0) {
          alert(this.No_Inv_Msg);
          return;
        }
        this.invoice_detail = data.data['list'][0];
        console.log(this.invoice_detail);

        this.supplier_inv_model['supplier_invoice_id'] = this.invoice_detail['supplier_invoice_id'];
        this.supplier_inv_model['invoice_no'] = this.invoice_detail['invoice_no'];
        (document.getElementById('invoice_no') as HTMLInputElement).value = this.invoice_detail['invoice_no'];
        this.supplier_inv_model['invoice_date'] = this.invoice_detail['invoice_date'];
        this.supplier_inv_model['supplier_no'] = this.invoice_detail['supplier_no'];
        this.model['supplier_no'] = this.invoice_detail['supplier_no'];

        // if (this.mode == 'edit')
        //   this.supplier_inv_model['invoice_no'] = this.invoice_detail['supplier_invoice_no'];
        //}
        //this.model['invoice_date'] = this.invoice_detail['invoice_date'];
        // this.supplier_inv_model['invoiceDate'] = new Date(this.invoice_detail['invoice_date']);
        // this.supplier_inv_model['has_supplier'] = (this.invoice_detail['supplier_no'] == '' ? '0' : '1');


        // if (this.invoice_detail['customer_no'] == '')
        //   (document.getElementById('customer_name') as HTMLInputElement).value = this.supplier_inv_model['customer_name'];
        // else {
        query = "SELECT * FROM `supplier` WHERE `acct_number` = '" + this.invoice_detail['supplier_no'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let supDetail = data.data['list'][0];
            if (supDetail != undefined)
              (document.getElementById('supplier_name') as HTMLInputElement).value = supDetail['acct_number'] +
                "-" + supDetail['supplier_name'] + "-" + supDetail['supplier_name_en'] + "-" +
                supDetail['mobile'];
            // this.customer_name = data.data['list'][0]['customer_name'];
            // this.mobile = data.data['list'][0]['mobile'];
          });

        if (this.invoice_detail['cost_center'] == '0')
          (document.getElementById('cost_center') as HTMLInputElement).value = this.Main;
        else {
          query = "SELECT `cc_name` FROM `cost_center` WHERE `cc_number` = '" + this.invoice_detail['cost_center'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              let ccDetail = data.data['list'][0];
              (document.getElementById('cost_center') as HTMLInputElement).value = ccDetail['cc_name'];
            });
        }
        this.model['cost_center'] = this.invoice_detail['cost_center'];
        this.supplier_inv_model['cost_center'] = this.invoice_detail['cost_center'];

        // }
        // if (this.mode != 'edit') {
        // }
        //this.model['comment'] = this.invoice_detail['comment'];
        this.supplier_inv_model['amount'] = this.invoice_detail['amount'];
        this.supplier_inv_model['discount'] = this.invoice_detail['discount'];
        this.supplier_inv_model['tax'] = this.invoice_detail['tax'];

        this.data_model['final_total'] = (Number(this.invoice_detail['amount']) -
          Number(this.invoice_detail['discount']) + Number(this.invoice_detail['tax'])).toFixed(2);

        if (this.mode == 'edit') {

          this.data_model['final_total_ret'] = (Number(this.invoice_detail['ret_total']) -
            Number(this.invoice_detail['ret_discount']) + Number(this.invoice_detail['ret_tax'])).toFixed(2);

          this.model['return_supplier_invoice_id'] = this.invoice_detail['return_supplier_invoice_id'];
          this.model['return_supplier_invoice_no'] = this.invoice_detail['return_supplier_invoice_no'];
          this.model['flag'] = 'update';
          this.model['total'] = this.invoice_detail['ret_total'];
          this.model['tax'] = this.invoice_detail['ret_tax'];
          this.model['discount'] = this.invoice_detail['ret_discount'];
          this.model['return_date'] = this.invoice_detail['return_date'];
          this.data_model['return_date'] = new Date(this.invoice_detail['return_date']);
          this.model['is_paid'] = this.invoice_detail['is_paid'];
          this.model['comment'] = this.invoice_detail['ret_comment'];
          this.model['branch_id'] = this.invoice_detail['branch_id'];

          // this.model['ret_purch_acct'] = this.invoice_detail['ret_sales_acct'];
          // this.model['payment_method'] = this.invoice_detail['payment_method'];
          // this.model['acct_number'] = this.invoice_detail['acct_number'];
        }

        this.supplier_inv_model['payment_date'] = this.invoice_detail['payment_date'];
        this.supplier_inv_model['transport_fee'] = this.invoice_detail['transport_fee'];
        this.supplier_inv_model['is_paid'] = this.invoice_detail['is_paid'];
        this.supplier_inv_model['status'] = this.invoice_detail['status'];
        this.supplier_inv_model['cost_center'] = this.invoice_detail['cost_center'];
        this.supplier_inv_model['purch_acct'] = this.invoice_detail['purch_acct'];
        this.supplier_inv_model['acct_number'] = this.invoice_detail['acct_number'];
        this.supplier_inv_model['tax_acct'] = this.invoice_detail['tax_acct'];
        this.supplier_inv_model['from_acct'] = this.invoice_detail['from_acct'];
        this.supplier_inv_model['payment_voucher_no'] = this.invoice_detail['payment_voucher_no'];
        this.supplier_inv_model['received'] = this.invoice_detail['received'];
        if (this.supplier_inv_model['is_paid'] == '1')
          this.data_model['is_paid'] = this.Paid;
        else
          this.data_model['is_paid'] = this.Unpaid;

        this.getInvoiceItems();

        if (this.mode == 'edit')
          this.getRetPaymentMethod();
        //this.getPaymentMethod();
      });
  }

  getRetPaymentMethod() {

    let query = "SELECT `ret_supp_inv_payment_method`.*, `payment_type`.*, 'update' AS 'flag'," +
      " `ret_supp_inv_payment_method`.`ret_supp_inv_payment_method_id` AS `inv_payment_method_id`," +
      " 'ret_supp_inv_payment_method_id' AS 'key' FROM `ret_supp_inv_payment_method`, " +
      "`payment_type` WHERE `ret_supp_inv_payment_method`.`return_supplier_invoice_no` = '" + this.no +
      "' AND `ret_supp_inv_payment_method`.`status` = '1' AND `ret_supp_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id`";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp1 = data.data['list'];
        this.dataSource1 = new MatTableDataSource(this.dp1);
        this.dataSource1.sort = this.sort;

        this.dp1.forEach(element => {
          if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {
            document.getElementById('tr_bank_acct').style.display = 'table-row';
            document.getElementById('tr_bank_acct2').style.display = 'table-row';

            this.data_model['bank_acct_number'] = element.acct_number;
            let query1 = "SELECT * FROM `bank_account` WHERE `acct_number` = '" + element.acct_number + "'";
            obj = { cmd: 'getList', query: query1 };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let acct_info = data.data['list'][0];
                (document.getElementById('search_value_10000') as HTMLInputElement).value = acct_info.bank_acct_number +
                  ' - ' + acct_info.acct_number + ' - ' + acct_info.account_name + ' - ' + acct_info.account_name_en;
              });
          }

          // ******************* Based on the invoice payment method fill amount, inv_payment_method_id and falg in All Payment Types array ******************* //
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == element.payment_type_id) {
              element1.amount = element.amount;
              element1.inv_payment_method_id = element.ret_supp_inv_payment_method_id;
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.inv_payment_method_id = '';
            }
            element1.flag = '';
          });
        });
        console.log(this.all_payment_types);
      });
  }

  getInvoiceItems() {
    this.dp = [];
    let obj;
    // obj = { cmd: 'getInvoiceItem', type: 'return_supplier_invoice', invoice_no: this.no, 
    //   inv_number: this.supplier_inv_model['invoice_no'] };
    if (this.mode == 'edit')
      obj = {
        cmd: 'getInvoiceItem', type: 'supplier_invoice', invoice_no: this.supplier_inv_model['invoice_no'],
        for_return: true, ret_invoice_no: this.model['return_supplier_invoice_no']
      };
    else
      obj = {
        cmd: 'getInvoiceItem', type: 'supplier_invoice', invoice_no: this.supplier_inv_model['invoice_no'],
        for_return: true
      };

    console.log(obj);
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.supplier_invoice_item = [];
        if (data.status['type'] == 'success')
          this.supplier_invoice_item = data.status['msg'];

        console.log(this.supplier_invoice_item);
        this.dp = this.supplier_invoice_item;
      });

  }

  // updateDP(element, element_count) {
  //   this.count++;
  //   //console.log(element);
  //   this.dp.push({
  //     'id': this.count, 'available_count': '', 'sub_item_unit': element.sub_item_unit,
  //     'sub_item_primary_qty': element.sub_item_primary_qty, 'sub_item_no': element.sub_item_no, 'supplier_invoice_item_id': element.supplier_invoice_item_id,
  //     'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name, 'unit_name': element.unit_name,
  //     'min_price': element.min_price, 'price': element.price, 'price_flex': element.price_flex, 'count': element.count,
  //     'min_sale_qty': element.min_sale_qty, 'total_price': String(Number(element.price) * Number(element.count)),
  //     'discount': element.discount, 'tax_no': element.tax_no, 'tax_amount': element.tax_amount,
  //     'net_price': String((Number(element.price) * Number(element.count)) - Number(element.discount) + Number(element.tax_amount)),
  //     'comment': element.comment
  //   });
  //   if (this.count == element_count)
  //     this.supplier_invoice_item = this.dp;
  // }

  changeFinalTotal() {

    if (this.model['total'] != '' && Number(this.model['total']) != 0) {
      let index;
      if (this.dp1.length == 0 || this.dp1.length > 1) {

        if (this.mode == 'edit') {
          let existed = false;

          // ******************* in the edit mode, change the payment method to default and change the flag of saved payment method to delete and remove it from array ******************* //
          for (let indx = this.dp1.length - 1; indx >= 0; indx--) {
            existed = false;

            for (index = 0; index < this.payment_list.length; index++) {
              if (this.payment_list[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                existed = true;
                break;
              }
            }

            if (!existed) {
              let flag = this.dp1[indx]['flag'];

              if (flag != 'new') {
                for (index = 0; index < this.all_payment_types.length; index++) {
                  if (this.all_payment_types[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                    this.all_payment_types[index]['amount'] = this.dp1[indx]['amount'];
                    this.all_payment_types[index]['flag'] = 'delete';
                    this.all_payment_types[index]['inv_payment_method_id'] = this.dp1[indx]['inv_payment_method_id'];

                    break;
                  }
                }
                //         this.dp1[index]['flag'] = 'delete';
                //         let inv_payment_method_id = this.dp1[index]['inv_payment_method_id'];
                //         if(inv_payment_method_id != '' && inv_payment_method_id != '0') {
                //           this.dp1[index]['table_name'] = 'inv_payment_method';
                //           this.toDelete.push(this.dp1[index]);
                //         }
              }
              //       else if(flag == 'new')
              //         this.dp1[index]['flag']  = '';

              this.dp1.splice(indx, 1);
            }
          }

          // ******************* in the edit mode, after changing the flag of saved payment method to delete and remove it from array. if array is empty, fill it with default payment ******************* //
          if (this.dp1.length == 0) {
            this.dp1 = this.payment_list;
            this.all_payment_types.forEach(element1 => {

              if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
                element1.amount = this.data_model['final_total'];
                if (element1.inv_payment_method_id != '')
                  element1.flag = 'update';
                else
                  element1.flag = 'new';

                return false;
              }
            });
          }
        }
        else {
          // ******************* in the new mode and after filling the array with default payment, change the flag to new ******************* //
          this.dp1 = this.payment_list;
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
              element1.amount = this.data_model['final_total_ret'];
              element1.flag = 'new';
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.flag = '';
            }

            element1.inv_payment_method_id = '';
          });
          // this.model['is_paid'] = '1';

          // this.model['is_paid'] = '1';
          // this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
          // //document.getElementById('tr_payment_date').style.display = 'none';
          // document.getElementById('tr_bank_acct').style.display = 'none';
        }
        this.model['is_paid'] = (this.dp1[0]['payment_type_key'] == 'credit' ? '0' : '1');
        this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
        //document.getElementById('tr_payment_date').style.display = 'none';
        document.getElementById('tr_bank_acct').style.display = 'none';
        document.getElementById('tr_bank_acct2').style.display = 'none';
      }
      this.dp1[0]['amount'] = this.data_model['final_total_ret'];

      // ******************* change the flag to new if there is no id and update if there is  ******************* //
      for (index = 0; index < this.all_payment_types.length; index++) {
        if (this.all_payment_types[index]['payment_type_id'] == this.dp1[0]['payment_type_id']) {
          this.all_payment_types[index]['amount'] = this.dp1[0]['amount'];
          console.log(this.dp1[0]['amount']);
          // this.all_payment_types[index]['flag'] = this.dp1[0]['flag'];

          if (this.all_payment_types[index]['inv_payment_method_id'] != '') {
            this.all_payment_types[index]['flag'] = 'update';
            // if (this.mode == 'edit') {
            //   this.all_payment_types[index]['amount'] = this.data_model['final_total_ret'];
            //   this.all_payment_types[index]['ret_supp_inv_payment_method_id'] = this.dp1[0]['ret_supp_inv_payment_method_id'];
            // }
          }
          else
            this.all_payment_types[index]['flag'] = 'new';

          break;
        }
      }
      // if (this.dp1.length == 1) {
      //   this.dp1.push({
      //     'payment_type_id': '0', 'payment_type_key': 'total', 'payment_type_name': 'المجموع المدخل',
      //     'payment_type_name_en': 'Total', 'amount': this.data_model['final_total_ret']
      //   });
      // }
      // else if (this.dp1.length == 2)
      //   this.dp1[1]['amount'] = this.data_model['final_total_ret'];

    }
    else {
      if (this.mode == 'edit') {
        this.all_payment_types.forEach(element1 => {
          element1.amount = '';
          if (element1.inv_payment_method_id == '') {
            element1.flag = '';
          }
        });
      }
      else {
        this.all_payment_types.forEach(element1 => {
          element1.amount = '';
          element1.flag = '';
          element1.inv_payment_method_id = '';
        });
      }
      this.dp1 = [];
      // this.payment_method = '';
    }
    this.dataSource1 = new MatTableDataSource(this.dp1);
    this.dataSource1.sort = this.sort;
    console.log(this.all_payment_types);
  }

  addPayment() {
    if (this.model['total'] != '' && this.model['total'] != '0') {
      let dialog_data = {
        'total_amount': this.data_model['final_total_ret'], 'payment_methods': this.dp1,
        'all_payment_types': this.all_payment_types
      };
      this.payDialogRef = this.dialog.open(SuppInvPaymentMethodComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.payDialogRef
        .afterClosed()
        .subscribe(result => {
          if (result['payment_methods'] != undefined && Array.isArray(result['payment_methods'])) {
            let credit_existed = false;
            let bank_existed = false;
            //console.log(this.dp1);

            result['payment_methods'].forEach(element => {
              if (element.payment_type_key == 'credit')
                credit_existed = true;
              else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
                bank_existed = true;
            });
            // document.getElementById('tr_payment_date').style.display = (credit_existed ? 'table-row' : 'none');
            document.getElementById('tr_bank_acct').style.display = (bank_existed ? 'table-row' : 'none');
            document.getElementById('tr_bank_acct2').style.display = (bank_existed ? 'table-row' : 'none');
            this.model['is_paid'] = (credit_existed ? '0' : '1');

            this.dp1 = result['payment_methods'];

            this.dataSource1 = new MatTableDataSource(this.dp1);
            this.dataSource1.sort = this.sort;

            if (result['all_payment_types'] != undefined && Array.isArray(result['all_payment_types']))
              this.all_payment_types = result['all_payment_types'];
            // this.total_entered = this.dp1['0']['total_entered'];
            console.log(this.all_payment_types);
          }
        });
    }
    else
      alert(this.One_Item_Msg);
  }

  onChangeBank = function (search_result: object) {
    this.data_model['bank_acct_number'] = search_result['no'];
    console.log(this.data_model['bank_acct_number']);
    // ******************* In Edit Mode, change flag for bank or visa payment method to update if there is ******************* //
    if (this.mode == 'edit') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
  }

  onChange = function (dpList: any) {
    this.dp = dpList;
    this.changeFinalTotal();
  }

  saveInvoice(save_type) {
    let is_cash = false;
    let is_bank = false;
    this.dp1.forEach(element => {
      if (element.payment_type_key == 'cash')
        is_cash = true;
      else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
        is_bank = true;
    });

    if (this.model['total'] == '' || Number(this.model['total']) == 0) {
      alert(this.One_Item_Msg);
      return;
    }

    if (this.dp1.length == 0) {
      alert(this.Pay_Msg);
      return;
    }

    if (is_cash && this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      return;
    }

    if (is_bank && this.data_model['bank_acct_number'] == '0') {
      alert(this.Bank_Acct_Msg);
      return;
    }

    this.model['return_date'] = (this.data_model['return_date'].getFullYear() + "-" + (this.data_model['return_date'].getMonth() + 1) + "-"
      + this.data_model['return_date'].getDate() + ' ' + this.data_model['return_date'].getHours() + ':' + this.data_model['return_date'].getMinutes() +
      ':' + this.data_model['return_date'].getSeconds());

    this.model['supplier_invoice_no'] = this.supplier_inv_model['invoice_no'];
    // this.model['tax_acct'] = this.supplier_inv_model['tax_acct'];
    // this.model['ret_purch_acct'] = this.applicationConstants.ret_purch_acct;

    let is_equal_tax = true;
    let is_equal_ret = true;
    let first_tax_no = '';
    let first_ret_no = '';
    this.dp.forEach(element => {
      if (element.return_count != '' && Number(element.return_count) > 0) {
        if (first_tax_no == '') {
          first_tax_no = element.tax_no;
          first_ret_no = element.purch_ret_acct_no;
        }
        else {
          if (element.tax_no != first_tax_no)
            is_equal_tax = false;

          if (element.purch_ret_acct_no != first_ret_no)
            is_equal_ret = false;
        }
      }

    });

    if (is_equal_tax)
      this.model['tax_acct'] = first_tax_no;
    if (is_equal_ret)
      this.model['ret_purch_acct'] = first_ret_no;

    if (this.dp1.length == 1) {
      if (this.dp1[0].payment_type_key == 'credit')
        this.model['acct_number'] = this.supplier_inv_model['supplier_no'];
      else if (this.dp1[0].payment_type_key == 'cash')
        this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
      else if (this.dp1[0].payment_type_key == 'bank' || this.dp1[0].payment_type_key == 'visa')
        this.model['acct_number'] = this.data_model['bank_acct_number'];

      this.model['payment_method'] = this.dp1[0].payment_type_key;
    }
    else {
      this.model['acct_number'] = '0';
      this.model['payment_method'] = '';
    }

    //this.model['comment'] = this.inv_model['tax_acct'];
    let values = [];
    values.push(this.model);

    let return_count, comment;
    //let counter;

    // let values1 = [];
    // let where = [];
    // let total_ret_tax = 0;

    this.dp.forEach(element => {
      return_count = (document.getElementById('return_count_' + element.id) as HTMLInputElement).value;
      comment = (document.getElementById('comment_' + element.id) as HTMLInputElement).value;
      if ((this.mode != 'edit' && return_count != '' && return_count != '0') || this.mode == 'edit') {

        if (this.mode == 'edit' && (return_count == '' || Number(return_count) == 0))
          element.flag = 'delete';
        // let flag = 'new';
        // let return_item_id = '0';
        // if (this.mode == 'edit') {
        //   flag = element.flag;
        //   return_item_id = element.return_item_id;
        // } 

        values.push({
          'table_name': 'return_supplier_invoice_item',
          'return_supplier_invoice_no': this.model['return_supplier_invoice_no'],
          'supplier_invoice_item_id': element.supplier_invoice_item_id,
          'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name,
          'return_count': return_count, 'price': element.price, 'unit_id': element.unit_id,
          'return_tax': (Number(element.return_tax)).toFixed(2), 'total_price': (Number(element.return_total_price)).toFixed(2),
          'discount': (Number(element.return_discount)).toFixed(2), 'tax_no': element.tax_no, 'stock_no': element.stock_no,
          'return_date': this.model['return_date'], 'store_id': element.store_id,
          'primary_sub_item_number': element.primary_sub_item_number,
          'flag': element.flag, 'key': element.key, 'return_item_id': element.return_item_id,
          'primary_quantity': (element.stock_no != '0' && element.stock_no != '' ? (Number(return_count) * Number(element.primary_quantity)).toFixed(2) : '0'),
          'comment': comment, 'purch_ret_acct_no': element.purch_ret_acct_no
        });

        // return_invoice_no  invoice_item_id  	return_count  return_tax   total_price  comment  	status 
        // return_tax = (document.getElementById('return_tax_' + element.id) as HTMLInputElement).value;
        // net_price = (document.getElementById('return_total_' + element.id) as HTMLInputElement).value;
        // total_price = (net_price - return_tax).toFixed(2);
        // supplier_invoice_item_id = (document.getElementById('supplier_invoice_item_id_' + element.id) as HTMLInputElement).value;
        //damage = ((document.getElementById('damage_' + element.id) as HTMLInputElement).checked ? '1' : '0');
        //console.log(damage);

        // for the items
        // values.push({
        //   'table_name': 'return_supplier_invoice_item', 'return_supplier_invoice_no': '', 'supplier_invoice_item_id': supplier_invoice_item_id,
        //   'return_count': return_count, 'return_tax': return_tax, 'total_price': total_price, 'comments': comment
        // });

      }
    });

    let acct_number, inv_payment_method_id;
    this.all_payment_types.forEach(element1 => {
      if (element1.flag != '') {
        if (element1.payment_type_key == 'cash')
          acct_number = this.applicationConstants.user_info.casher_acct_number;
        else if (element1.payment_type_key == 'credit')
          acct_number = this.supplier_inv_model['supplier_no'];
        else if (element1.payment_type_key == 'bank' || element1.payment_type_key == 'visa')
          acct_number = this.data_model['bank_acct_number'];

        inv_payment_method_id = element1.inv_payment_method_id;
        if (inv_payment_method_id == '' || inv_payment_method_id == null || inv_payment_method_id == undefined ||
          inv_payment_method_id == 'undefined')
          inv_payment_method_id = '0';

        // if (this.mode == 'edit')
        //   inv_payment_method_id = element1.ret_supp_inv_payment_method_id;

        if (element1.amount == '')
          element1.amount = '0';

        values.push({
          'table_name': 'ret_supp_inv_payment_method', 'return_supplier_invoice_no': this.model['return_supplier_invoice_no'],
          'ret_supp_inv_payment_method_id': inv_payment_method_id, 'flag': element1.flag, 'key': 'ret_supp_inv_payment_method_id',
          'payment_type_id': element1.payment_type_id, 'acct_number': acct_number, 'amount': element1.amount
        });
      }
    });

    // this.dp1.forEach(element1 => {
    //   let acct_number;
    //   if (element1.payment_type_id != '0') {
    //     if (element1.payment_type_key == 'cash')
    //       acct_number = this.applicationConstants.user_info.casher_acct_number;
    //     else if (element1.payment_type_key == 'credit')
    //       acct_number = this.supplier_inv_model['supplier_no'];
    //     else if (element1.payment_type_key == 'bank' || element1.payment_type_key == 'visa')
    //       acct_number = this.model['acct_number'];

    //     this.model['payment_method'] = element1.payment_type_key;
    //     values.push({
    //       'table_name': 'ret_supp_inv_payment_method', 'return_supplier_invoice_no': '',
    //       'payment_type_id': element1.payment_type_id, 'acct_number': acct_number, 'amount': element1.amount
    //     });
    //   }
    // });

    // if (this.dp1.length > 2) {
    //   this.model['acct_number'] = '0';
    //   this.model['payment_method'] = '';
    // }
    // else
    //   this.model['acct_number'] = values[values.length - 1]['acct_number'];

    console.log(values);
    //return; 

    let current_year = new Date().getFullYear();
    let prefix = 'RET-' + this.model['branch_id'] + "-" + current_year;
    let obj;
    if (this.mode == 'edit')
      obj = { cmd: 'updateAdv', values: values };
    else
      obj = {
        cmd: 'add', values: values, pk: 'return_supplier_invoice_no', id: 'return_supplier_invoice_id',
        main_table: 'return_supplier_invoice', prefix: prefix
      };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          //let invoice_no = data.status['msg'][0]['number'];
          let ret_invoice_no;
          if (this.mode == 'edit')
            ret_invoice_no = this.no;
          else
            ret_invoice_no = data.status['msg'][0]['number'];
          alert(this.Success_Msg + this.Ret_No_Msg + ret_invoice_no); // :  " + invoice_no

          if (save_type == 'print' && this.print_type == 'normal')
            window.open(this.applicationConstants.generatePDF + "?type=return_supplier_invoice&no=" + ret_invoice_no, "_blank");

          this.router.navigate(['sub_menu/7/return_supplier_invoice_list']);
        }
        else
          alert(this.Error_Msg);
      });

  }


}
